export default {
  bearbeiten: "1d761616-7bbd-486e-88eb-1626d3b26af8",
  erfolg: "6acf334c-d5fd-411e-9dff-536949f7bebf",
  misserfolg: "9da607d6-940f-4913-a1e5-8f7d9a7c4c97",
};
